import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-150" data-mp="2z2p7czw6jftu">
      <div className="mx-auto max-w-2xl" data-id="element-151" data-mp="2z51vxvwg0ofv">
        <SectionHeading eyebrow="FAQ" title="Frequently asked questions" data-id="element-152" data-mp="3mtulnamh2021" />

        <ul className="mt-9 space-y-3 sm:mt-12" data-id="element-153" data-mp="3rrmlcqtcyqgs">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-154" data-mp="3d2q9eio6ktaw" data-mpi={index}>
                <h3 data-id="element-155" data-mp="3hzqdio1gzlzd">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-50 sm:px-6" data-id="element-156" data-mp="9mjdwzfx62d7">
                    <span className="text-[15px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-157" data-mp="2agrwc2pprj51">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-brick-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-158" data-mp="25nyq1aelk2qu" />
                  </button>
                </h3>
                {isOpen ? <div id={`faq-panel-${index}`} className="px-4 pb-4 sm:px-6 sm:pb-5" data-id="element-159" data-mp="2oh2nz7yul1r9">
                    <p className="text-[14px] font-medium leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-160" data-mp="z1wj8l6ptpql">
                      {faq.answer}
                    </p>
                  </div> : null}
              </li>;
        })}
        </ul>

        <div className="mt-10 sm:mt-12" data-id="element-161" data-mp="1nrhb0yd54nkc">
          <CTAButton label="I have no more doubts — I want it" subline="One-time $27 payment • Lifetime access • 7-day guarantee" data-id="element-162" data-mp="1nsala9bb5v78" />
        </div>
      </div>
    </section>;
}